import $ from 'jquery'



export const show = (object, message, status, type) => {
    if (status === "success") {
        $(object).before("<div class= 'success_notify'><span>" + message + "</span></div >");
    }
    else {
        $(object).before("<i class='notify_message'>" + message + "</i>");
        if (type == "1") {
            $(object).addClass("error_value");
        }
    }
}

export const hide = () => {
    $(".success_notify").remove();
    $(".notify_message").remove();
    $(".error_value").removeClass("error_value")
}



// WEBPACK FOOTER //
// ./src/notification.js